import classNames from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsTournamentsByUsers} from '../../../../../../actions/entities/statistics/tournaments';
import earthFlag from '../../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../../components/Loader';
import numeral from 'numeral';

class TournamentsByUserWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: 'FR'};
  }

  fetchStats() {
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsTournamentsByUsers({}, null, (type, error) =>
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'FR'});
    } else {
      this.setState({lang: value});
    }
  }

  renderTournamentsByUser() {
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang];

    if (!isFetching && table) {
      return (
        table && (
          <div className="mb-4">
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <tbody>
                  <tr className="text-center">
                    <th className="text-left">Min</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.min).format('0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-left">Max</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.max).format('0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-left">Moyenne</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.average).format('0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-left">Q1</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.q1).format('0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-left">Q2</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.q2).format('0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-left">Q3</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.q3).format('0')}
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th className="text-left">Nombre total d'utilisateurs</th>
                    <th style={{width: '300px'}} className="text-center">
                      {numeral(table.totalOfUsers).format('0')}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  render() {
    const {lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="userConnections-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-trophy" /> Tournois par utilisateur
            </h3>
            <br />
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTournamentsByUser()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.tournamentsByUsers,
  dispatch => ({dispatch}),
)(TournamentsByUserWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Tournaments/ByUser/index.js